import { memo, useMemo } from 'react';
import { Handle, Position } from 'reactflow';
import { Image } from 'react-bootstrap';
import './nodeStyles.css';
import addUpload from "../../assets/icons/addNodes.svg";
import removeUpload from "../../assets/icons/removeNodes.svg";
import { findNextNode } from '../../utilities/Nodes/getConnectedChildNodes';
import { UploadButtonNodeProps } from '../../utilities/types/common';
import { handleRemoveConnected } from '../../utilities/Nodes/commonFunctions';
import { useTranslation } from "react-i18next";
import { useFlowDataContext } from '../../context/workbench/FlowDataContext';
import { usePermission } from '../../hooks/usePermission';

const UploadButtonNode = ({ data, id }: UploadButtonNodeProps) => {
    const flowDataContext = useFlowDataContext();
    const { canView, canEdit } = usePermission();

    const { t } = useTranslation("common");
    const handleAdd = (type: string) => {
        if (typeof data.onAdd === 'function') {
            data.onAdd(id, type);
        } else {
            console.error('onAdd is not a function:', data.onAdd);
        }
    }

    const nextNode = useMemo(() => findNextNode(id, flowDataContext?.edges, flowDataContext?.nodes), [id, flowDataContext?.edges, flowDataContext?.nodes]);

    return (
        <div className="add-button-container">
            <div className={`add-button-node ${nextNode ? "remove" : "upload"}`}>
                <p className="mb-0 button-text">{t('buttons.upload')}</p>
                {canView && canEdit && (
                    <>
                        {nextNode ? <Image src={removeUpload} alt="removeIcon" className="removeIcon pe-2" onClick={() => handleRemoveConnected(data, id)} /> : <Image src={addUpload} alt="addIcon" className="addIcon pe-2" onClick={() => handleAdd("upload")} />}
                    </>
                )}

                <Handle type="target" position={Position.Left} className="handle" id="left-handle" />
                <Handle type="source" position={Position.Right} className="handle" id="right-handle" />
            </div>
        </div>
    );
};

export default memo(UploadButtonNode);